import { render, staticRenderFns } from "./text2Dialog.vue?vue&type=template&id=e1826006&scoped=true"
import script from "./text2Dialog.vue?vue&type=script&lang=js"
export * from "./text2Dialog.vue?vue&type=script&lang=js"
import style0 from "./text2Dialog.vue?vue&type=style&index=0&id=e1826006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1826006",
  null
  
)

export default component.exports